var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page live-list"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section live"},[_c('Live')],1),_c('div',{staticClass:"section live"},[_c('LiveHistory',{attrs:{"is-mobile":_vm.isMobile}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }